import * as React from "react";
const SvgUnsavedChangesDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: "9.2px", height: "11px", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 3, r: 2.8 }));
export default SvgUnsavedChangesDot;
